import { render, staticRenderFns } from "./KabDogiyai.vue?vue&type=template&id=62cd73e2"
import script from "./KabDogiyai.vue?vue&type=script&lang=js"
export * from "./KabDogiyai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports